import _regeneratorRuntime from "/var/jenkins_home/workspace/online-k8s-web-product-cloudv2@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/online-k8s-web-product-cloudv2@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-02d773f2"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  key: 0,
  class: "password-tip"
};
import info from '@/api/info';
import { $formErr, $logout, $checkPassword } from '@/assets/common/common.js';
import { useLang } from '@/hooks/lang';
import { XlButton, XlDialog, XlInput, XlMessage } from '@shining3d/ui-components';
import { VueCookieNext } from 'vue-cookie-next';
import { useStore } from 'vuex';
export default {
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;
    var _useLang = useLang('@shining3d/app'),
      $t = _useLang.$t;
    var $store = useStore();
    var dialogVisible = ref(false);
    var submitLoading = ref(false);
    var formRef = ref(false);
    var hasPwd = ref($store.state.userInfo.hasPwd);
    var form = reactive({
      uID: VueCookieNext.getCookie('user_id'),
      password: '',
      newpassword: '',
      repeatPassword: ''
    });
    var formErr = ref({});
    var repeatPasswordValidate = function repeatPasswordValidate(rule, value, callback) {
      if (value !== form.newpassword) {
        callback(new Error($t('rules.atypismPassword')));
      } else {
        callback();
      }
    };

    // 去除复制粘贴中的空格
    var handlePaste = function handlePaste(event) {
      var clipboardData = event.clipboardData || window.clipboardData;
      var pastedData = clipboardData.getData('text/plain').toString().trim();
      clipboardData.setData('text/plain', pastedData); // 去除空格后重新设置剪贴板的内容
    };
    var rules = ref({
      password: [{
        required: true,
        message: $t('rules.notEmpty'),
        trigger: 'blur'
      }, {
        required: true,
        message: $t('rules.notEmpty'),
        trigger: 'blur'
      }],
      newpassword: [{
        required: true,
        message: $t('rules.notEmpty'),
        trigger: 'blur'
      }, {
        trigger: 'blur',
        validator: function validator(rule, value, callback) {
          if (!$checkPassword(value)) {
            // 翻译
            callback(new Error($t('rules.passWord832')));
          } else {
            callback();
          }
        }
      }],
      repeatPassword: [{
        required: true,
        message: $t('rules.notEmpty'),
        trigger: 'blur'
      }, {
        validator: repeatPasswordValidate,
        trigger: 'blur'
      }]
    });
    var closeDialog = function closeDialog() {
      console.log(form);
      for (var key in form) {
        key === 'uID' ? form[key] = VueCookieNext.getCookie('user_id') : form[key] = '';
      }
      for (var _key in formErr.value) {
        formErr.value[_key] = '';
      }
      formRef.value.resetFields();
      dialogVisible.value = false;
    };
    var onSubmit = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(formEl) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (formEl) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              _context2.next = 4;
              return formEl.validate(/*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(valid, fields) {
                  var _yield$info$cpoPassWo, result, status;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if (!valid) {
                          _context.next = 9;
                          break;
                        }
                        submitLoading.value = true;
                        _context.next = 4;
                        return info.cpoPassWord(form);
                      case 4:
                        _yield$info$cpoPassWo = _context.sent;
                        result = _yield$info$cpoPassWo.result;
                        status = _yield$info$cpoPassWo.status;
                        if (status === 'success') {
                          XlMessage({
                            type: 'success',
                            message: $t('messages.successEdit')
                          });
                          closeDialog();
                          $logout();
                        } else {
                          $formErr(result, formErr.value);
                        }
                        submitLoading.value = false;
                      case 9:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x2, _x3) {
                  return _ref3.apply(this, arguments);
                };
              }());
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function onSubmit(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    expose({
      dialogVisible: dialogVisible
    });
    return function (_ctx, _cache) {
      var _component_el_form_item = _resolveComponent("el-form-item");
      var _component_el_form = _resolveComponent("el-form");
      var _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createBlock(_unref(XlDialog), {
        "destroy-on-close": "",
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
          return dialogVisible.value = $event;
        }),
        title: _unref($t)('personalInformation.passWord.passWord'),
        width: "400px",
        "before-close": closeDialog
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_form, {
            "inline-message": "",
            model: _unref(form),
            rules: rules.value,
            ref_key: "formRef",
            ref: formRef,
            autocomplete: "off"
          }, {
            default: _withCtx(function () {
              return [hasPwd.value ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                prop: "password",
                error: formErr.value.password
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_unref(XlInput), {
                    type: "password",
                    "show-password": "",
                    placeholder: _unref($t)('personalInformation.passWord.oldPassWord'),
                    modelValue: _unref(form).password,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                      return _unref(form).password = $event;
                    }),
                    autocomplete: "new-password"
                  }, null, 8, ["placeholder", "modelValue"])];
                }),
                _: 1
              }, 8, ["error"])) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
                prop: "newpassword",
                error: formErr.value.newpassword
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_unref(XlInput), {
                    type: "password",
                    "show-password": "",
                    onPaste: handlePaste,
                    placeholder: _unref($t)('personalInformation.passWord.newPassWord'),
                    modelValue: _unref(form).newpassword,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                      return _unref(form).newpassword = $event;
                    }),
                    modelModifiers: {
                      trim: true
                    },
                    autocomplete: "new-password"
                  }, null, 8, ["placeholder", "modelValue"]), !_unref(form).newpassword ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref($t)('rules.passWord832')), 1)) : _createCommentVNode("", true)];
                }),
                _: 1
              }, 8, ["error"]), _createVNode(_component_el_form_item, {
                prop: "repeatPassword"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_unref(XlInput), {
                    type: "password",
                    "show-password": "",
                    onPaste: handlePaste,
                    placeholder: _unref($t)('personalInformation.passWord.atypismPassword'),
                    modelValue: _unref(form).repeatPassword,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                      return _unref(form).repeatPassword = $event;
                    }),
                    modelModifiers: {
                      trim: true
                    },
                    autocomplete: "new-password"
                  }, null, 8, ["placeholder", "modelValue"])];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["model", "rules"]), _createVNode(_component_el_row, {
            class: "footer"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_unref(XlButton), {
                onClick: closeDialog
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_unref($t)("button.cancel")), 1)];
                }),
                _: 1
              }), _createVNode(_unref(XlButton), {
                type: "primary",
                loading: submitLoading.value,
                onClick: _cache[3] || (_cache[3] = function ($event) {
                  return onSubmit(formRef.value);
                })
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_unref($t)("button.determine")), 1)];
                }),
                _: 1
              }, 8, ["loading"])];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["modelValue", "title"]);
    };
  }
};